<div class="wrapper">
  <div class="wrapper-content">
    <div class="main">

      <div class="title">
        @if (noContent) {
          {{ 'Content not available' | translate }}
        } @else {
          {{ '404. Page not found!' | translate }}
        }
      </div>


      <div class="main-text">

        @if (noContent) {
          <p>{{ 'The content you are trying to access is not available in' | translate }} <b>{{ currentFrItem.country }}
            ({{ currentFrItem.language }})</b></p>
          <p>{{ 'If you believe this is a mistake or need access, please contact the administration for assistance.' | translate }}</p>
        } @else {
          <p>{{ 'We apologize for the inconvenience, but the page you were trying to access is not at this address. You can use the links below to help you find what you are looking for.' | translate }}</p>
          <p>{{ 'If you are certain you have the correct web address but are encountering an error, please contact the Site Administration.'|translate }}</p>
        }


      </div>
      <div class="footer">
        <div class="actions">
          <app-button [ariaLabel]="'Back home'|translate" (clicked)="goHome()" [buttonStyleType]="BUTTON_TYPES.PRIMARY_0">{{ 'Back home'|translate }}
          </app-button>
          <app-button [ariaLabel]="'Contact Administration'|translate" (clicked)="mail()">{{ 'Contact Administration'|translate }}</app-button>
        </div>

        <!--  TODO - feature functionality

                <app-horizontal-divider></app-horizontal-divider>
                <div class="language">
                  <span class="icon-Lang"></span> {{ 'View this page in another language'|translate }}:
                  <span (click)="changeLanguage(E_FR_LOC.en)"
                        [class.active]="currentTranslate === E_FR_LOC.en"
                        class="link">English</span>
                  <img alt="page not found" height="4" ngSrc="assets/images/dot.svg" width="4">
                  <span (click)="changeLanguage(E_FR_LOC.caFr)"
                        [class.active]="currentTranslate === E_FR_LOC.fr"
                        class="link">Français</span>
                  <img alt="page not found" height="4" ngSrc="assets/images/dot.svg" width="4">
                  <span (click)="changeLanguage(E_FR_LOC.de)"
                        [class.active]="currentTranslate === E_FR_LOC.de"
                        class="link">Deutsch</span>
                </div>

        -->
      </div>
    </div>
    <div class="image-404">
      @if (noContent) {
        <img alt="page not found" height="200" ngSrc="assets/images/no-content.svg" width="150">
      } @else {
        <img alt="page not found" height="200" ngSrc="assets/images/file-image.svg" width="200">
      }

    </div>
  </div>
</div>
